export default [
    { 
        id: 1, 
        url: 'hansgrohe',
        name: 'Hansgrohe',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/hansgrohe/hansgrohe_1.jpg',
                '../assets/img/pics/hansgrohe/hansgrohe_2.jpg',
                '../assets/img/pics/hansgrohe/hansgrohe_3.jpg',
                '../assets/img/pics/hansgrohe/hansgrohe_4.jpg',
                '../assets/img/pics/hansgrohe/hansgrohe_5.jpg',
            ],
            ru: {
                title: 'Инновационные решения для ванной комнаты и кухни',
                about: 'Основатель бренда – Ханс Гроэ – стал настоящим революционером в области дизайна ванной комнаты и кухни, предложив поистине великолепную сантехнику для самых взыскательных покупателей.',
            },
            en: {
                title: 'Innovative bathroom and kitchen solutions',
                about: 'The founder of the brand, Hans Grohe, has become a true revolutionary in the field of bathroom and kitchen design, offering truly excellent sanitary ware for the most discerning buyers.',
            },
            website: 'http://www.hansgrohe.ru'
        }
    },
    { 
        id: 2, 
        url: 'axor',
        name: 'AXOR',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/axor/axor_1.jpg',
                '../assets/img/pics/axor/axor_2.jpg',
                '../assets/img/pics/axor/axor_3.jpg',
                '../assets/img/pics/axor/axor_4.jpg',
                '../assets/img/pics/axor/axor_5.jpg',
                '../assets/img/pics/axor/axor_6.jpg',
                '../assets/img/pics/axor/axor_7.jpg'
            ],
            title: 'Сантехника, как атрибут роскошного стиля жизни!',
            about: 'Выбор настоящих ценителей безукоризненного и утонченного стиля каждой детали! Все коллекции бренда создаются в результате совместной работы с известными дизайнерами и архитекторами, реализовывая самые яркие дизайнерские и технические идеи.',
            website: 'https://www.axor-design.com'
        }
    },
    { 
        id: 3, 
        url: 'geberit',
        name: 'Geberit',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/geberit/geberit_1.jpg',
                '../assets/img/pics/geberit/geberit_2.jpg',
                '../assets/img/pics/geberit/geberit_3.jpg',
                '../assets/img/pics/geberit/geberit_4.jpg',
                '../assets/img/pics/geberit/geberit_5.jpg',
                '../assets/img/pics/geberit/geberit_6.jpg'
            ],
            title: 'Geberit – больше ста лет в лидерах!',
            about: 'Бренд заботится не только о техническом качестве продукции, но и ее безупречном внешнем виде. Исповедуя инновационный подход, компания гордится своими инженерными и дизайнерскими наработками, предлагая долговечные, новаторские и функциональные решения для сантехнической продукции, диктуя высочайшие стандарты всему рынку.',
            website: 'https://www.geberit.ru'
        }
    },
    { 
        id: 4, 
        url: 'nicolazzi',
        name: 'Nicolazzi',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/nicolazzi/nicolazzi_1.jpg',
                '../assets/img/pics/nicolazzi/nicolazzi_2.jpg',
                '../assets/img/pics/nicolazzi/nicolazzi_3.jpg',
                '../assets/img/pics/nicolazzi/nicolazzi_4.jpg',
                '../assets/img/pics/nicolazzi/nicolazzi_5.jpg',
                '../assets/img/pics/nicolazzi/nicolazzi_6.jpg',
                '../assets/img/pics/nicolazzi/nicolazzi_7.jpg',
                '../assets/img/pics/nicolazzi/nicolazzi_8.jpg',
                '../assets/img/pics/nicolazzi/nicolazzi_9.jpg'
            ],
            title: 'Nicolazzi – уникальная коллекция элегантности, роскоши и функциональности!',
            about: 'Знаменитый бренд Nicolazzi ведет свою историю с далекого 1960 года. За время своего существования компания смогла накопить бесценный опыт в производстве высококачественной продукции, а также завоевать внимание и доверие самых взыскательных клиентов.',
            website: 'http://www.nicolazzi.it'
        }
    },
    { 
        id: 5, 
        url: 'villeroyboch',
        name: 'Villeroy & Boch',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/villeroyboch/villeroyboch_1.jpg',
                '../assets/img/pics/villeroyboch/villeroyboch_2.jpg',
                '../assets/img/pics/villeroyboch/villeroyboch_3.jpg',
                '../assets/img/pics/villeroyboch/villeroyboch_4.jpg',
                '../assets/img/pics/villeroyboch/villeroyboch_5.jpg',
                '../assets/img/pics/villeroyboch/villeroyboch_6.jpg',
                '../assets/img/pics/villeroyboch/villeroyboch_7.jpg',
                '../assets/img/pics/villeroyboch/villeroyboch_8.jpg',
                '../assets/img/pics/villeroyboch/villeroyboch_9.jpg',
                '../assets/img/pics/villeroyboch/villeroyboch_10.jpg'
            ],
            title: 'Villeroy & Boch – жизнь под знаком безукоризненного стиля и комфорта!',
            about: 'Истоки компании лежат в производстве фарфора и керамики, начатом в 1748 году. Сегодня бренд из небольшого предприятия превратился в символ высочайшего качества и инноваций. Накопленный опыт нашел свое отражение в роскошных коллекциях сантехники, одновременно поражающей своей функциональностью и красотой.',
            website: 'https://www.villeroy-boch.it'
        }
    },
    { 
        id: 6, 
        url: 'toto',
        name: 'TOTO',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/toto/toto_1.jpg',
                '../assets/img/pics/toto/toto_2.jpg',
                '../assets/img/pics/toto/toto_3.jpg',
                '../assets/img/pics/toto/toto_4.jpg'
            ],
            title: 'ТОТО – продукция, которая находится на вершине инновационных разработок!',
            about: 'Использование в производственном процессе лишь самых новых технологий и ультрасовременных материалов позволило компании из небольшого предприятия превратится в культовый торговый бренд, пользующийся заслуженным вниманием покупателей с разных уголков мира.',
            website: 'https://toto.com'
        }
    },
    { 
        id: 7, 
        url: 'gessi',
        name: 'GESSI',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/gessi/gessi_1.jpg',
                '../assets/img/pics/gessi/gessi_2.jpg',
                '../assets/img/pics/gessi/gessi_3.jpg',
                '../assets/img/pics/gessi/gessi_4.jpg',
                '../assets/img/pics/gessi/gessi_5.jpg',
                '../assets/img/pics/gessi/gessi_6.jpg'
            ],
            title: 'GESSI – превосходные эксплуатационные параметры, надежность и уникальные дизайнерские решения!',
            about: 'Коллекции создаются в собственном дизайнерском бюро или в тесном тандеме с ведущими художниками своего поколения. Вся продукция разработана таким образом, чтобы открыть возможность для самых смелых интерьерных экспериментов.',
            website: 'http://www.gessi.com'
        }
    },
    { 
        id: 8, 
        url: 'miaitalia',
        name: 'MIA Italia',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/miaitalia/miaitalia_1.jpg',
                '../assets/img/pics/miaitalia/miaitalia_2.jpg',
                '../assets/img/pics/miaitalia/miaitalia_3.jpg',
                '../assets/img/pics/miaitalia/miaitalia_4.jpg',
                '../assets/img/pics/miaitalia/miaitalia_5.jpg',
                '../assets/img/pics/miaitalia/miaitalia_6.jpg',
                '../assets/img/pics/miaitalia/miaitalia_7.jpg'
            ],
            title: 'MIA Italia – безукоризненный стиль от классики и до Авангарда!',
            about: 'В каждой детали в каждой линии изделий бренда Mia Italia видна виртуозность и мастерство и чувственность ее авторов, черпающих свое вдохновение в богатейшем культурном наследии Италии. Это позволяет создавать уникальные вещи, которые выходят за рамки привычной ванной мебели.',
            website: 'http://miaitaliabath.it'
        } 
    },
    { 
        id: 9, 
        url: 'margaroli',
        name: 'Margaroli',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/margaroli/margaroli_1.jpg',
                '../assets/img/pics/margaroli/margaroli_2.jpg',
                '../assets/img/pics/margaroli/margaroli_3.jpg',
                '../assets/img/pics/margaroli/margaroli_4.jpg',
                '../assets/img/pics/margaroli/margaroli_5.jpg',
                '../assets/img/pics/margaroli/margaroli_6.jpg'
            ],
            title: 'Margaroli – непревзойденный стиль интерьера, как образ жизни!',
            about: 'Все коллекции продукции Margaroli отличаются нескучным и поистине неотразимым дизайном. Роскошный итальянский стиль - это то, что лучше всего способно описать продукцию бренда и придать вашей ванной комнате стильный современный внешний вид.',
            website: 'https://www.margaroli.com'
        }
    },
    { 
        id: 10, 
        url: 'gaia',
        name: 'GAIA',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/gaia/gaia_1.jpg',
                '../assets/img/pics/gaia/gaia_2.jpg',
                '../assets/img/pics/gaia/gaia_3.jpg',
                '../assets/img/pics/gaia/gaia_4.jpg',
                '../assets/img/pics/gaia/gaia_5.jpg',
                '../assets/img/pics/gaia/gaia_6.jpg'
            ],
            title: 'GAIA – компания, которая всегда «держит марку»!',
            about: 'Работая в различных направлениях, мастера создают сантехнику для интерьеров в любом стиле. Плавность линий и интересные дизайнерские решения – то, что превращает сантехнику этого бренда в универсальный выбор для самых роскошных и комфортных ванных комнат.',
            website: 'http://www.gaiamobili.com'
        }
    },
    { 
        id: 11, 
        url: 'eurodesign',
        name: 'Eurodesign',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/eurodesign/eurodesign_1.jpg',
                '../assets/img/pics/eurodesign/eurodesign_2.jpg',
                '../assets/img/pics/eurodesign/eurodesign_3.jpg',
                '../assets/img/pics/eurodesign/eurodesign_4.jpg',
            ],
            title: 'Eurodesign – уникальное сочетание элегантной роскоши и уюта!',
            about: 'Будучи вдохновленными Эпохой Возрождения, дизайнеры бренда Eurodesign создают уникальные модели мебели и аксессуаров для ванной комнаты в классическом стиле. Атмосферой аристократической старины, корнями уходящей в ремесленнические традиции итальянской провинции, пропитаны буквально все изделия.',
            website: 'http://www.eurodesignbagno.com'
        }
    },
    { 
        id: 12, 
        url: 'vismaravetro',
        name: 'Vismaravetro',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/vismaravetro/vismaravetro_1.jpg',
                '../assets/img/pics/vismaravetro/vismaravetro_2.jpg',
                '../assets/img/pics/vismaravetro/vismaravetro_3.jpg',
                '../assets/img/pics/vismaravetro/vismaravetro_4.jpg',
                '../assets/img/pics/vismaravetro/vismaravetro_5.jpg',
                '../assets/img/pics/vismaravetro/vismaravetro_6.jpg',
                '../assets/img/pics/vismaravetro/vismaravetro_7.jpg',
                '../assets/img/pics/vismaravetro/vismaravetro_8.jpg'
            ],
            title: 'Vismaravetro – итальянская сантехника для современных ванных комнат!',
            about: 'Мастера компании специализируются на производстве современных душевых кабин, используя концептуально новый подход – модульное наполнение. Таким образом, покупатели имеют возможность обустроить свою ванную комнату с максимальным комфортом, выбирая конкретные дизайны и размеры.',
            website: 'https://www.vismaravetro.it'
        }
    },
    { 
        id: 13, 
        url: 'hueppe',
        name: 'Hueppe',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/hueppe/hueppe_1.jpg',
                '../assets/img/pics/hueppe/hueppe_2.jpg',
                '../assets/img/pics/hueppe/hueppe_3.jpg',
                '../assets/img/pics/hueppe/hueppe_4.jpg',
                '../assets/img/pics/hueppe/hueppe_5.jpg',
                '../assets/img/pics/hueppe/hueppe_6.jpg',
                '../assets/img/pics/hueppe/hueppe_7.jpg',
                '../assets/img/pics/hueppe/hueppe_8.jpg'
            ],
            title: 'Hueppe – душ и душа!',
            about: 'Философия этого знаменитого бренда, занимающегося производством душевых кабин, основывается на принципиально новом взгляде на пространство ванной комнаты. Здесь больше нет места обыденности и скучной простоте, ведь на смену им приходит функциональность и красота в каждой линии.',
            website: 'https://www.hueppe.com'
        }
    },
    { 
        id: 14, 
        url: 'cielo',
        name: 'Ceramica CIELO',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/cielo/cielo_1.jpg',
                '../assets/img/pics/cielo/cielo_2.jpg',
                '../assets/img/pics/cielo/cielo_3.jpg',
                '../assets/img/pics/cielo/cielo_4.jpg',
                '../assets/img/pics/cielo/cielo_5.jpg',
                '../assets/img/pics/cielo/cielo_6.jpg',
                '../assets/img/pics/cielo/cielo_7.jpg',
                '../assets/img/pics/cielo/cielo_8.jpg',
                '../assets/img/pics/cielo/cielo_9.jpg',
                '../assets/img/pics/cielo/cielo_10.jpg'
            ],
            title: 'Эксклюзивные аксессуары для ванной комнаты!',
            about: 'Весь цикл работ по созданию сантехники Ceramica Cielo подчинен замыслу дизайнера. Абсолютно новый взгляд и новаторские дизайнерские решения – это то, что позволило продукции этого бренда стать неповторимой и эксклюзивной.',
            website: 'http://www.ceramicacielo.com'
        }
    },
    { 
        id: 15, 
        url: 'ravak',
        name: 'Ravak',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/ravak/ravak_1.jpg',
                '../assets/img/pics/ravak/ravak_2.jpg',
                '../assets/img/pics/ravak/ravak_3.jpg',
                '../assets/img/pics/ravak/ravak_4.jpg',
                '../assets/img/pics/ravak/ravak_5.jpg',
                '../assets/img/pics/ravak/ravak_6.jpg',
                '../assets/img/pics/ravak/ravak_7.jpg',
                '../assets/img/pics/ravak/ravak_8.jpg',
                '../assets/img/pics/ravak/ravak_9.jpg'
            ],
            title: 'Ravak – красивая ванная для каждого дома!',
            about: 'На сегодняшний день бренд Ravak является одним из самых заметных игроков профильного рынка. Продукция это чешской торговой марки поставляется в разные уголки мира для оборудования действительно роскошных и максимально удобных ванных комнат.',
            website: 'https://www.ravak.ru'
        }
    },
    { 
        id: 16, 
        url: 'artceram',
        name: 'Art Ceram',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/artceram/artceram_1.jpg',
                '../assets/img/pics/artceram/artceram_2.jpg',
                '../assets/img/pics/artceram/artceram_3.jpg',
                '../assets/img/pics/artceram/artceram_4.jpg',
                '../assets/img/pics/artceram/artceram_5.jpg'
            ],
            title: 'Art Ceram – стремление найти что-то необычное в обычных вещах!',
            about: 'На первое место помимо безупречного качества мастера Art Ceram выводят также индивидуальность и неповторимость. Тонкое сочетание доскональной геометрии, плавных и гибких линий придают изделию утонченность, а насыщенные оттенки отдельных деталей вовсе не выбиваются из общего настроения.',
            website: 'http://www.artceram.it'
        } 
    },
    { 
        id: 17, 
        url: 'antoniolupi',
        name: 'Antonio Lupi',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/antoniolupi/antoniolupi_1.jpg',
                '../assets/img/pics/antoniolupi/antoniolupi_2.jpg',
                '../assets/img/pics/antoniolupi/antoniolupi_3.jpg',
                '../assets/img/pics/antoniolupi/antoniolupi_4.jpg',
                '../assets/img/pics/antoniolupi/antoniolupi_5.jpg',
                '../assets/img/pics/antoniolupi/antoniolupi_6.jpg',
                '../assets/img/pics/antoniolupi/antoniolupi_7.jpg',
                '../assets/img/pics/antoniolupi/antoniolupi_8.jpg',
                '../assets/img/pics/antoniolupi/antoniolupi_9.jpg',
                '../assets/img/pics/antoniolupi/antoniolupi_10.jpg'
            ],
            title: 'Antonio Lupi – итальянский шарм в сочетании с японской утонченностью!',
            about: 'Бренд удивляет потребителей действительно интересными сочетаниями южного очарования пейзажами прекрасной Флоренции и традиционного японского аскетизма. Простые формы и гибкие линии, гармонично впишутся в пространство современных интерьеров.',
            website: 'https://www.antoniolupi.it'
        } 
    },
    { 
        id: 18, 
        url: 'thgparis',
        name: 'THG Paris',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/thgparis/thgparis_1.jpg',
                '../assets/img/pics/thgparis/thgparis_2.jpg',
                '../assets/img/pics/thgparis/thgparis_3.jpg',
                '../assets/img/pics/thgparis/thgparis_4.jpg',
                '../assets/img/pics/thgparis/thgparis_5.jpg',
                '../assets/img/pics/thgparis/thgparis_6.jpg',
                '../assets/img/pics/thgparis/thgparis_7.jpg',
                '../assets/img/pics/thgparis/thgparis_8.jpg',
                '../assets/img/pics/thgparis/thgparis_9.jpg',
                '../assets/img/pics/thgparis/thgparis_10.jpg',
                '../assets/img/pics/thgparis/thgparis_11.jpg',
                '../assets/img/pics/thgparis/thgparis_12.jpg',
                '../assets/img/pics/thgparis/thgparis_13.jpg',
                '../assets/img/pics/thgparis/thgparis_14.jpg',
                '../assets/img/pics/thgparis/thgparis_15.jpg',
            ],
            title: 'THG Paris – мир удовольствия от дизайнерской элитной сантехники!',
            about: 'Сочетание традиционного ремесленного и современного индустриального производства позволяет добиться поразительных результатов. THG Paris гордится своим французским происхождением, привлекая к разработке новых коллекций именитых парижских дизайнеров и художников, чтобы представить свое уникальное видение Парижа во всем его великолепии и блеске.',
            website: 'https://www.thg-paris.com'
        }
    },
    { 
        id: 19, 
        url: 'duravit',
        name: 'Duravit',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/duravit/duravit_1.jpg',
                '../assets/img/pics/duravit/duravit_2.jpg',
                '../assets/img/pics/duravit/duravit_3.jpg',
                '../assets/img/pics/duravit/duravit_4.jpg',
                '../assets/img/pics/duravit/duravit_5.jpg',
                '../assets/img/pics/duravit/duravit_6.jpg',
                '../assets/img/pics/duravit/duravit_7.jpg',
                '../assets/img/pics/duravit/duravit_8.jpg',
                '../assets/img/pics/duravit/duravit_9.jpg',
            ],
            title: 'Duravit – реализация идеи «живой ванной комнаты»!',
            about: 'Даже самые большие бренды начинали свой путь когда-то из небольших предприятий. Именно так проходило развитие компании Duravit, которая была основана в 1817 году и позднее выросшая в крупное предприятие по производству современной сантехники.',
            website: 'https://www.duravit.com'
        }
    },
    { 
        id: 20, 
        url: 'bagnodesign',
        name: 'Bagnodesign',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/bagnodesign/bagnodesign_1.jpg',
                '../assets/img/pics/bagnodesign/bagnodesign_2.jpg',
                '../assets/img/pics/bagnodesign/bagnodesign_3.jpg',
                '../assets/img/pics/bagnodesign/bagnodesign_4.jpg',
                '../assets/img/pics/bagnodesign/bagnodesign_5.jpg',
                '../assets/img/pics/bagnodesign/bagnodesign_6.jpg',
                '../assets/img/pics/bagnodesign/bagnodesign_7.jpg',
                '../assets/img/pics/bagnodesign/bagnodesign_8.jpg',
            ],
            title: 'Bagnodesign – сантехника с чисто английским шармом и обаянием!',
            about: 'Изделия Bagnodesign украшают интерьер ванных комнат в самых респектабельных домах и дорогих отелях, великолепных резиденций и люксовых апартаментов во всех уголках мира. Эта сантехника легко снискала популярность у самых требовательных и взыскательных покупателей.',
            website: 'https://www.bagnodesignlondon.com'
        }
    },
    { 
        id: 21, 
        url: 'ferplast',
        name: 'Ferplast',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/ferplast/ferplast_1.jpg',
                '../assets/img/pics/ferplast/ferplast_2.jpg',
                '../assets/img/pics/ferplast/ferplast_3.jpg',
                '../assets/img/pics/ferplast/ferplast_4.jpg',
                '../assets/img/pics/ferplast/ferplast_5.jpg',
            ],
            title: 'Ferplast - утонченная элегантность стали!',
            about: 'Многолетний опыт работы мастеров Ferplast позволяет им в каждой новой коллекции продукции вновь и вновь доказывать, что такое подлинный «итальянский стиль». Каждое изделие бренда наделено не только высочайшими эксплуатационными параметрами, но и элегантным дизайном даже в самых незначительных мелочах.',
            website: 'http://www.ferplastsrl.com'
        }
    },
    { 
        id: 22, 
        url: 'stilhaus',
        name: 'Stilhaus',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/stilhaus/stilhaus_1.jpg',
                '../assets/img/pics/stilhaus/stilhaus_2.jpg',
                '../assets/img/pics/stilhaus/stilhaus_3.jpg',
                '../assets/img/pics/stilhaus/stilhaus_4.jpg',
                '../assets/img/pics/stilhaus/stilhaus_5.jpg',
            ],
            title: '',
            about: '',
            website: 'https://www.stilhaus.it'
        }
    },
    { 
        id: 23, 
        url: 'jobst',
        name: 'Jobst',
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/jobst/jobst_1.jpg',
                '../assets/img/pics/jobst/jobst_2.jpg',
                '../assets/img/pics/jobst/jobst_3.jpg',
                '../assets/img/pics/jobst/jobst_4.jpg',
            ],
            title: '',
            about: '',
            website: 'https://www.jobst-salon.de'
        }
    },
    { 
        id: 24,
        url: 'zehnder',
        name: 'Zehnder', 
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/zehnder/zehnder_10.jpg',
                '../assets/img/pics/zehnder/zehnder_11.jpg',
                '../assets/img/pics/zehnder/zehnder_12.jpg',
                '../assets/img/pics/zehnder/zehnder_13.jpg',
                '../assets/img/pics/zehnder/zehnder_14.jpg',
                '../assets/img/pics/zehnder/zehnder_15.jpg',
            ],
            title: 'Zehnder – всегда вокруг вас!',
            about: 'Продукция Zehnder предлагает самые инновационные и энергоэффективные решения для создания здорового микроклимата в помещениях. Изделия данного бренда помимо многофункциональных систем представляют собой еще и утонченные объекты дизайна, которые органично вписываются в интерьер и становятся неотъемлемой частью пространства.',
            website: 'https://www.zehndergroup.com'
        }
    },
    { 
        id: 25,
        url: 'devondevon',
        name: 'Devon Devon', 
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/devondevon/devondevon_1.jpg',
                '../assets/img/pics/devondevon/devondevon_2.jpg',
                '../assets/img/pics/devondevon/devondevon_3.jpg',
                '../assets/img/pics/devondevon/devondevon_4.jpg',
            ],
            title: 'Devon & Devon - Флорентийское наследие, вдохновение мира, любовь к качеству и повторение пространства',
            about: 'D&D - это эксклюзивный способ насладиться вашим домом. Выбор качества основан на любви к сырью и исключительных производственных навыках мастеров. Выражение вкуса, характеризующееся неподвластными времени продуктами, воссоздающими и переосмысливающими лучшие европейские традиции и дизайн двадцатого века, с внимательным акцентом на настоящее. От штаб-квартиры во Флоренции до магазинов по всему миру - компания предлагает все необходимое, чтобы сделать каждое место домом, в котором вы чувствуете себя хорошо и всегда хотите вернуться.',
            website: 'https://www.devon-devon.com'
        }
    },
    { 
        id: 26,
        url: 'oasis',
        name: 'Oasis', 
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/oasis/oasis_1.jpg',
                '../assets/img/pics/oasis/oasis_2.jpg',
                '../assets/img/pics/oasis/oasis_3.jpg',
                '../assets/img/pics/oasis/oasis_4.jpg',
                '../assets/img/pics/oasis/oasis_5.jpg',
            ],
            title: 'Oasis - Итальянская история',
            about: 'Oasis – это семейный бизнес, история которого насчитывает более ста лет и чьи принципы зиждутся на смелости, традициях и силе личности. В настоящее время компания Oasis присутствует на рынках более 25 стран. Портфолио продукции компании Oasis включает в себя широкий выбор коллекций мебели для ванных комнат',
            website: 'https://www.oasisgroup.it'
        }
    },
    { 
        id: 27,
        url: 'ideagroup',
        name: 'Idea Group', 
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/ideagroup/ideagroup_1.jpg',
                '../assets/img/pics/ideagroup/ideagroup_2.jpg',
                '../assets/img/pics/ideagroup/ideagroup_3.jpg',
                '../assets/img/pics/ideagroup/ideagroup_4.jpg',
            ],
            title: 'Концерн Idea Group, лидер в области дизайна современной мебели для ванной',
            about: 'Idea Group - является синонимом качества, динамизма, научных исследований, технологии, гибкости оптимизации производства к созданию инновационной мебели и аксессуаров для ванной комнаты. Цель компании - способствовать эволюции вкуса, предлагая новые идеи по обустройству ванной комнаты и персональные решения по её зонированию',
            website: 'https://www.ideagroup.it'
        }
    },
    { 
        id: 28,
        url: 'glassdesign',
        name: 'Glass Design', 
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/glassdesign/bathrooms/glassdesign_1.jpg',
                '../assets/img/pics/glassdesign/bathrooms/glassdesign_2.jpg',
                '../assets/img/pics/glassdesign/bathrooms/glassdesign_3.jpg',
                '../assets/img/pics/glassdesign/bathrooms/glassdesign_4.jpg',
                '../assets/img/pics/glassdesign/bathrooms/glassdesign_5.jpg',
                '../assets/img/pics/glassdesign/bathrooms/glassdesign_6.jpg',
                '../assets/img/pics/glassdesign/bathrooms/glassdesign_7.jpg',
            ],
            title: 'Glass Design - это итальянское превосходство в производстве и дизайне умывальников для интерьера!',
            about: 'Компания Glass Design, расположенная в Винчи, сердце Тосканы и города Леонардо да Винчи, была основана в 1984 году семьей Борселлини после многолетнего опыта в производстве художественного стекла.',
            website: 'https://www.glassdesign.it'
        }
    },
    { 
        id: 29,
        url: 'aquamarina',
        name: 'Aqua Marina', 
        parent: 'bathrooms',
        content: {
            pics: [
                '../assets/img/pics/aquamarina/aquamarina_1.jpg',
                '../assets/img/pics/aquamarina/aquamarina_2.jpg',
                '../assets/img/pics/aquamarina/aquamarina_3.jpg',
            ],
            title: 'Aqua Marina не производит, а творит!',
            about: 'Дизайн и инновации, исследования и разработки соответствуют методам работы великих мастеров. Слияние латуни с землей, итальянского хрусталя, муранского стекла, шелка и органзы, украшенных элементами Swarovski, не принесет вам никаких компромиссов.',
            website: 'https://www.ilparalumemarina.com'
        }
    }
]